import {Component, OnDestroy, OnInit} from '@angular/core';
import {PostDO} from '../../common/data-objects/PostDO';
import { PostsService } from '../../common/services/posts.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from 'src/app/common/services/seo.service';
import {Subscription} from 'rxjs';
import {Utils} from '../../common/utils/Utils';

@Component({
  selector: 'app-single-song-page',
  templateUrl: './single-song-page.component.html',
  styleUrls: ['./single-song-page.component.scss'],
})
export class SingleSongPageComponent implements OnInit, OnDestroy {
  post: PostDO;
  isLoading: boolean;
  slug: string;
  private paramMapSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService,
    private postsService: PostsService
  ) {
    this.paramMapSubscription = this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.slug = paramMap.get('slug');
    });
  }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    if (this.paramMapSubscription) {
      this.paramMapSubscription.unsubscribe();
    }
  }

  private getData() {
    this.isLoading = true;
    this.postsService.getPostBySlug(this.slug).subscribe((post) => {
      this.post = post;
      const title = `${Utils.removeUnicode(this.post.title.rendered)} - Fun Bible`;
      this.seoService.setTitle(title);
      this.isLoading = false;
      this.seoService.setDescription(`Cantec despre ${post.title.rendered}`);
      this.meta.updateTag({ property: 'og:url', content: `https://funbible.net/songs/${post.slug}`});
      this.meta.updateTag({
        property: 'og:image',
        content: this.post.featuredImage
      });
      const initialKeywords = ['cantece crestine', 'muzica pentru copii', 'cantecele pentru copii', 'melodii pentru copii', 'muzica copii'];
      const dynamicKeywords = this.post.readableTagNames.slice(0, 5);
      const finalKeywords = [...dynamicKeywords, ...initialKeywords].join();
      this.meta.updateTag({property: 'keywords', content: finalKeywords});

      this.angulartics2.eventTrack.next({
        action: post.title.rendered,
        properties: { category: 'pageView' },
      });
    }, () => {
      this.toastr.error('Acest conținut nu există!');
      this.isLoading = false;
    });
  }
}
